export default {
    orderArrayByField: (arrayToOrder: any, desiredOrder: any, field: any) => {
        return arrayToOrder.sort((a: any, b: any) => {
            const indexA = desiredOrder.indexOf(a[field]);
            const indexB = desiredOrder.indexOf(b[field]);
            return indexA - indexB;
        });        
    },
    getRandomBetween(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
	generateUuid() {
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4();
	}
}

function s4 () {
	return Math.floor((1 + Math.random()) * 0x10000)
	.toString(16)
	.substring(1);
}